<template>
  <div class="container">
    <loading v-if="loadingRender"></loading>
    <panel v-if="!NeedEstelam" Title=" اطلاعات کاربری" Des="ازطریق این فرم میتوانید اطلاعات هویتی خود را مشاهده و تصحیح کنید. همچنین میتوانید رمز عبور خود را تغییر دهید." :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <div class="row my-2">
      <div class="row col-12"></div>

      <div class="col-1"></div>
      <div class="col-md-10 col-12 p-2">
        <net-pa-card>
          <template v-slot:header>
            <h6><i class="fas fa-user-edit"></i> اطلاعات هویتی</h6>
          </template>
          <template v-slot:content>
            <div class="row" v-if="NeedEstelam == true">
              <div class="col-12">
                <div class="alert alert-warning text-center">
                  <div class="">کاربر گرامی اطلاعات هویتی شما ناقص می باشد ، لطفا موارد خواسته شده را تکمیل کنید</div>
                </div>
              </div>
            </div>
            <div class="row" v-if="EstlamSuccess == false && NeedEstelam == true">
              <div class="col-12">
                <div class="alert alert-info text-center">
                  <h5>برای دریافت کد احراز هویت کد ملی ، شماره موبایل و تاریخ تولد خود را وارد کنید.</h5>
                  <span>برای احراز هویت شما نیاز است شماره موبایل و تاریخ تولد شما با اطلاعات واقعی شما مطابقت داشته باشد </span>
                </div>
              </div>
              <div class="col-12 col-md-3"></div>
              <div class="col-12 col-md-6 px-5">
                <form v-if="stage == 1" :id="'stage' + stage">
                  <input class="form-control text-center required" disabled v-model="DataAxiosEstelamSabtAhval.CodeMeli" type="number" placeholder="کد ملی" autocomplete="off" @keypress="$ValidNumber($event, 10)" />
                  <div class="row">
                    <div class="col-md-6 col-12"><input class="form-control text-center mt-2 required" type="text" id="Mobile" name="Mobile" placeholder="شماره موبایل" autocomplete="off" v-model="DataAxiosEstelamSabtAhval.Mobile" @keypress="$ValidNumber($event, 11)" /></div>
                    <div class="col-md-6 col-12 mt-2"><date-picker input-class="required form-control" :editable="true" color="#756AB6" autocomplete="off" placeholder="تاریخ تولد" v-model="DataAxiosEstelamSabtAhval.BirthDate"></date-picker></div>
                  </div>
                  <button class="btn btn-submit w-100 mt-4" @click.prevent="sendSms('stage' + stage)">ارسال کد احراز هویت</button>
                </form>
                <form v-if="stage == 2" :id="'stage' + stage">
                  <small>کد احراز هویت پیامک شده بر روی تلفن همراه خود را وارد نمایید</small>
                  <input class="form-control mt-2 text-center required" placeholder="کد احراز هویت" type="number" @keypress="$ValidNumber($event, 10)" v-model="randomKey" />
                  <button class="btn btn-submit w-100 mt-2" @click.prevent="OkCode('stage' + stage)">تایید کد پیامکی</button>
                </form>
              </div>
              <div class="col-12 col-md-3"></div>
            </div>

            <div class="row" id="userInfoDiv">
              <nav>
                <div class="col-12">
                  <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a v-if="showTab(0)" class="nav-item nav-link text-dark active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true"> اطلاعات هویتی</a>
                    <a v-if="showTab(1)" class="nav-item nav-link text-dark" id="nav-BankAccount-tab" data-toggle="tab" href="#nav-BankAccount" role="tab" aria-controls="nav-BankAccount" aria-selected="false">حسابهای بانکی</a>
                    <a v-if="showTab(2)" class="nav-item nav-link text-dark" id="nav-Account-tab" data-toggle="tab" href="#nav-pass" role="tab" aria-controls="nav-pass" aria-selected="false">تنظیمات امنیتی</a>
                    <a v-if="showTab(3)" class="nav-item nav-link text-dark" id="nav-file-tab" data-toggle="tab" href="#nav-file" role="tab" aria-controls="nav-file" aria-selected="false">بارگذاری مدارک </a>
                    <a v-if="showTab(4)" class="nav-item nav-link text-dark" id="nav-Isar-tab" data-toggle="tab" href="#nav-Isar" role="tab" aria-controls="nav-Isar" aria-selected="false">وضعیت ایثارگری</a>
                    <!-- <a class="nav-item nav-link text-dark" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false">...</a> -->
                  </div>
                </div>
              </nav>
              <div class="col-12">
                <div class="tab-content" id="nav-tabContent">
                  <div class="col-12 tab-pane active show fade" id="nav-home" v-if="showTab(0)" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="row pt-4">
                      <div class="col-12 mt-2 mb-4 text-center" v-if="($session.get('UserInfoNetPa').isEstelamSabtAhval == true && JSON.parse($cookies.get('IsrequiredEstelamSabtAhval')) == true)">
                        <div class="row">
                          <div class="col-md-4 col-12 text-md-left text-center">
                            <i class="fas fa-user-shield text-success fa-5x"></i>
                          </div>
                          <div class="col-md-8 col-12 text-md-right text-center mt-2">
                            <h5 class="mx-2 text-success mb-2">احراز هویت  با موفقیت انجام شده</h5>
                            <h7 class="mx-2 text-success mb-2">اطلاعات هویتی شما (توسط سامانه ثبت احوال) مورد تایید میباشد</h7>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 col-12 my-1">
                        <small>نام</small>
                        <input type="text" :disabled="!canChange.canChangeOzvName || FixInput == true" class="form-control" placeholder="نام" v-model="UserInfo.ozvName" />
                      </div>
                      <div class="col-md-4 col-12 my-1">
                        <small>نام خانوادگی</small>
                        <input type="text" :disabled="!canChange.canChangeOzvFamily || FixInput == true" class="form-control text-right" placeholder="نام خانوادگی" v-model="UserInfo.ozvFamily" />
                      </div>
                      <div class="col-md-4 col-12 my-1">
                        <small>کدملی</small>
                        <input type="text" :disabled="!canChange.canChangeCodeMeli || FixInput == true" class="form-control text-left required-CodeMeli" placeholder="کد ملی" v-model="UserInfo.codeMeli" />
                      </div>
                      <div class="col-md-4 col-12 my-1">
                        <small>شماره عضویت</small>
                        <input type="text" disabled class="form-control text-left" placeholder="شماره مشتری" v-model="UserInfo.shomareOzv" />
                      </div>
                      <div class="col-md-4 col-12 my-1">
                        <small>شماره همراه</small>
                        <input type="text" :disabled="!canChange.canChangeMobile || FixInput == true" class="form-control text-left" placeholder="شماره همراه" v-model="UserInfo.mobile" />
                      </div>
                      <div class="col-md-4 col-12 my-1">
                        <small>تلفن</small>
                        <input type="text" :disabled="!canChange.canChangeTel" class="form-control text-left" placeholder="تلفن ثابت" v-model="UserInfo.tel" />
                      </div>
                      <div class="col-md-4 col-12 my-1">
                        <small>تاریخ تولد</small>
                        <date-picker :editable="true" :disabled="!canChange.canChangeBirthDate || FixInput == true" :auto-submit="true" color="rgb(94 163 30)" v-model="UserInfo.birthDate"></date-picker>
                        <input type="text text-left" :disabled="!canChange.canChangeBirthDate || FixInput == true" tabindex="-1" class="d-none InputText" style="direction: ltr" />
                      </div>
                      <div class="col-md-4 col-12 my-1">
                        <small>نام پدر</small>
                        <input type="text" class="form-control" :disabled="!canChange.canChangePedar || FixInput == true" placeholder="نام پدر" v-model="UserInfo.pedar" />
                      </div>
                      <div class="col-md-4 col-12 my-1">
                        <small>شماره شناسنامه</small>
                        <input type="text" class="form-control text-left required" :disabled="!canChange.canChangeShenasname" placeholder="شماره شناسنامه" v-model="UserInfo.shenasname" />
                      </div>
                      <div class="col-12 col-md-4 my-1">
                        <small>آدرس ایمیل</small>
                        <input type="text" class="form-control text-left" dir="ltr" :disabled="!canChange.canChangeEmail" placeholder="ایمیل" v-model="UserInfo.email" />
                      </div>
                      <div class="col-md-8 col-12 my-1">
                        <small>آدرس</small>
                        <input type="text" class="form-control" placeholder="آدرس" :disabled="!canChange.canChangeAdres" v-model="UserInfo.adres" />
                      </div>
                      <div class="col-md-4 col-12 my-1" v-if="$session.get('CustCode') != '932'">
                        <small>سال ورود به سازمان</small>
                        <input type="text" :disabled="true" class="form-control" placeholder="سال ورود" v-model="UserInfo.tarixEmp" />
                      </div>
                      <div class="col-md-4 col-12 my-1" v-if="$session.get('CustCode') != '932'">
                        <small> رسته خدمت</small>
                        <input type="text" :disabled="true" class="form-control" placeholder="رسته خدمت" />
                      </div>
                      <div class="col-md-4 col-12 my-1" v-if="$session.get('CustCode') != '932'">
                        <small> مدرک تحصیلی</small>
                        <input type="text" :disabled="true" class="form-control" placeholder="مدرک تحصیلی" v-model="UserInfo.tblComboIdTahsilat316" />
                      </div>
                      <div class="col-md-4 col-12 my-1" v-if="$session.get('CustCode') != '932'">
                        <small> محل کار</small>
                        <input type="text" :disabled="$session.get('CustCode') != 886" class="form-control" placeholder=" محل کار" v-model="UserInfo.mahalKar" />
                      </div>
                      <div class="col-md-4 col-12 my-1" v-if="$session.get('CustCode') != '932'">
                        <small>سنوات خدمت(ماه-سال)</small>
                        <input type="text" :disabled="true" class="form-control" placeholder="سنوات" :value="UserInfo.sanavatSal + '-' + UserInfo.sanavatMah" />
                      </div>
                      <div class="col-md-4 col-12 my-1" v-if="$session.get('CustCode') != '932'">
                        <small>نوع اشتغال</small>
                        <SelectCombo @result="getSelectedCombo" :grp="24" :defaultItemId="UserInfo.comboIdNoeEstekhdam33" :disabled="FixInput == true"></SelectCombo>
                        <!-- <input type="text" :disabled="$session.get('CustCode') != 886" class="form-control" placeholder=" نوع اشتغال" v-model="UserInfo.ComboIdNoeEstekhdam33" /> -->
                      </div>
                      <div class="col-md-4 col-12 my-1" v-if="$session.get('CustCode') != '932'">
                        <small> شهر محل خدمت </small>
                        <input type="text" :disabled="true" class="form-control" placeholder=" شهر محل خدمت" v-model="UserInfo.tblComboIdGrp11WorkCity" />
                      </div>
                      <div class="col-md-4 col-12 my-1" v-if="$session.get('CustCode') != '932'">
                        <small>محل تولد</small>
                        <input type="text" :disabled="true" class="form-control" placeholder="محل تولد" v-model="UserInfo.mahalSodor" />
                      </div>
                      <div class="col-md-4 col-12 my-1" v-if="$session.get('CustCode') != '932'">
                        <small>رسته سازمانی</small>
                        <input type="text" :disabled="true" class="form-control" placeholder="رسته سازمانی" v-model="UserInfo.rasteSazmani" />
                      </div>
                      <div class="col-md-4 col-12 my-1" v-if="$session.get('CustCode') != '932'">
                        <small>پست سازمانی</small>
                        <input type="text" :disabled="$session.get('CustCode') != 886" class="form-control" placeholder="پست سازمانی" v-model="UserInfo.postSazmani" autocomplete="off" />
                      </div>
                    </div>
                    <div class="d-flex col-12 justify-content-end mt-2">
                      <button v-if="$session.get('UserInfoNetPa').cId != '801'" class="btn btn-success NetPa-btn float-left mt-2 w-25" @click="UpdateUser()">ثبت تغییرات</button>
                    </div>
                  </div>
                  <div class="col-12 tab-pane fade" id="nav-BankAccount" role="tabpanel" aria-labelledby="nav-BankAccount-tab">
                    
                    <button v-if="addBankAccount == false" class="btn btn-success my-2" @click="addBankAccount = true">اضافه کردن حساب بانکی</button>

                    <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config" :classes="classes" v-if="addBankAccount == false">
                      <template slot="sort-asc-icon">
                        <i class="fa fa-sort-up"></i>
                      </template>
                      <template slot="shebaNo" slot-scope="props">
                        <span dir="ltr">{{ props.row.shebaNo }}</span>
                      </template>
                      <template slot="sort-desc-icon">
                        <i class="fa fa-sort-down"></i>
                      </template>
                      <template slot="no-sort-icon">
                        <i class="fa fa-sort"></i>
                      </template>
                      <template slot="empty-results">
                        <p class="text-right">اطلاعاتی یافت نشد</p>
                      </template>
                    </vue-bootstrap4-table>

                    <div class="row" v-else id="addAccountBank">
                      <div class="col-md-4 col-12 my-1">
                        <small>نام صاحب حساب</small>
                        <input type="text" class="form-control required" v-model="bankAcoount.NameSahebHesab" :disabled="FixInput"/>
                      </div>
                      <div class="col-md-4 col-12 my-1" v-if="$session.get('CustCode') != '932'">
                        <small>شماره کارت</small>
                        <input type="text" class="form-control required" dir="ltr" @keypress="$ValidNumber($event, 16)" v-model="bankAcoount.CardNo" />
                      </div>
                      <div class="col-md-4 col-12 my-1">
                        <small>شماره حساب</small>
                        <input type="number" class="form-control required" dir="ltr" v-model="bankAcoount.HesabNo" />
                      </div>

                      <div class="col-md-4 col-12 my-1" v-if="$session.get('CustCode') != '932'">
                        <small>شماره شبا</small>
                        <div class="form-group row">
                          <div class="col-sm-10">
                            <input type="text" class="form-control required" dir="ltr" @keypress="$ValidNumber($event, 24)" v-model="bankAcoount.ShebaNo" />
                          </div>
                          <label class="col-sm-2 col-form-label fs-1">IR</label>
                        </div>
                      </div>

                      <!-- <div class="col-md-4 col-12 my-1">
                        <small>فعال</small>
                        <input type="checkbox" class="form-control"
                          v-model="bankAcoount.Active" />
                      </div> -->
                      <div class="col-md-4 col-12 my-1">
                        <small>بانک</small>
                        <SelectCombo @result="getSelectedBank" :readFromAction="'SelAzaHesab/GetBanks'"></SelectCombo>
                      </div>
                    </div>

                    <div class="row">
                      <button class="btn btn-success mx-3" v-if="addBankAccount" @click="submitBankAcoount()">ثبت</button>
                      <button v-if="addBankAccount" class="btn btn-danger" @click="addBankAccount = false">لغو</button>
                    </div>
                  </div>
                  <div class="col-12 tab-pane fade" id="nav-pass" role="tabpanel" aria-labelledby="nav-pass-tab">
                    <div class="row pt-4 px-3">
                      <div class="col-12 alert bg-dark-Custom NetPa-btn text-light text-right">
                        <span class="badge badge-warning my-2 p-1"> هشدار امنیتی</span>
                        <ul style="list-style: number; font-size: 15px" class="p-0">
                          <li>جهت جلوگیری از سوء استفاده ، رمز اینترنت بانک خودرا هر چندمدت یکبار تعویض نمایید .</li>
                          <li>برای امنیت بیشتر بهتر است ( رمز اینترنت بانک شما شامل حروف بزرگ و کوچک انگلیسی و اعداد باشد ) .</li>
                        </ul>
                      </div>
                    </div>
                    <div class="row px-3">
                      <div class="col-md-4 col-12 mt-1">
                        <input type="password" v-model="oldpass" class="form-control text-center" placeholder="رمز عبور فعلی" />
                      </div>
                      <div class="col-md-4 col-12 mt-1">
                        <input type="password" v-model="newpass" @keypress="checkregex($event)" class="form-control text-center" placeholder="رمز  جدید" />
                      </div>
                      <div class="col-md-4 col-12 mt-1">
                        <input type="password" v-model="newpasscomfirm" @keypress="checkregex($event)" class="form-control text-center" placeholder="تکرار رمز جدید" />
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-4 col-12"></div>
                      <div class="col-md-4 col-12"></div>
                      <div class="col-md-4 col-12 float-left">
                        <button class="btn btn-dark NetPa-btn float-left mt-2 w-100" @click="ChangePass">تغییر رمز &nbsp;</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 tab-pane fade" id="nav-file" role="tabpanel" aria-labelledby="nav-file-tab">
                    <!-- آپلودرها -->
                    <div class="row">
                      <div class="col-4 p-2 border rounded">
                        <div class="row">
                          <div class="col-12">
                            <uploader
                              :Idu="'shenasname1'"
                              v-if="$store.state.renderComponent"
                              :base64="GetBase(181070505)"
                              @Done="GetFile"
                              :attachId="GetId(181070505)"
                              :address="GetAddress(181070505)"
                              :grp="181070505"
                              :title="'صفحه اول شناسنامه'"
                              :MasterId="$session.get('UserInfoNetPa').wwwtblAzaId"
                            ></uploader>
                          </div>
                          <div class="col-12"></div>
                        </div>
                      </div>
                      <div class="col-4 p-2 border rounded">
                        <div class="row">
                          <div class="col-12">
                            <uploader
                              :Idu="'shenasname2'"
                              :base64="GetBase(181070506)"
                              @Done="GetFile"
                              v-if="$store.state.renderComponent"
                              :attachId="GetId(181070506)"
                              :address="GetAddress(181070506)"
                              :grp="181070506"
                              :title="'صفحه دوم شناسنامه'"
                              :MasterId="$session.get('UserInfoNetPa').wwwtblAzaId"
                            ></uploader>
                          </div>
                          <div class="col-12"></div>
                        </div>
                      </div>
                      <div class="col-4 p-2 border rounded">
                        <div class="row">
                          <div class="col-12">
                            <uploader
                              :Idu="'cartmeli1'"
                              @Done="GetFile"
                              :base64="GetBase(181070507)"
                              v-if="$store.state.renderComponent"
                              :attachId="GetId(181070507)"
                              :address="GetAddress(181070507)"
                              :grp="181070507"
                              :title="'تصویر جلوی کارت ملی'"
                              :MasterId="$session.get('UserInfoNetPa').wwwtblAzaId"
                            ></uploader>
                          </div>
                          <div class="col-12"></div>
                        </div>
                      </div>
                      <div class="col-4 p-2 border rounded">
                        <div class="row">
                          <div class="col-12">
                            <uploader
                              :Idu="'cartmeli2'"
                              :base64="GetBase(181070508)"
                              @Done="GetFile"
                              v-if="$store.state.renderComponent"
                              :attachId="GetId(181070508)"
                              :address="GetAddress(181070508)"
                              :grp="181070508"
                              :title="'تصویر پشت کارت ملی'"
                              :MasterId="$session.get('UserInfoNetPa').wwwtblAzaId"
                            ></uploader>
                          </div>
                          <div class="col-12"></div>
                        </div>
                      </div>
                      <div class="col-4 p-2 border rounded">
                        <div class="row">
                          <div class="col-12">
                            <uploader
                              :Idu="'others'"
                              @Done="GetFile"
                              :base64="GetBase(181070509)"
                              v-if="$store.state.renderComponent"
                              :attachId="GetId(181070509)"
                              :address="GetAddress(181070509)"
                              :grp="181070509"
                              :title="'سایر مدارک '"
                              :MasterId="$session.get('UserInfoNetPa').wwwtblAzaId"
                            ></uploader>
                          </div>
                          <div class="col-12"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 tab-Isar fade" id="nav-Isar" role="tabpanel" aria-labelledby="nav-Isar-tab">
                    <div class="row pt-4">
                      <div class="col-12">
                        <vue-bootstrap4-table :rows="rowsIsar" :columns="columnsIsar" :config="config" :classes="classes">
                          <template slot="sort-asc-icon">
                            <i class="fa fa-sort-up"></i>
                          </template>
                          <template slot="sort-desc-icon">
                            <i class="fa fa-sort-down"></i>
                          </template>
                          <template slot="no-sort-icon">
                            <i class="fa fa-sort"></i>
                          </template>
                          <template slot="empty-results">
                            <p class="text-right">اطلاعاتی یافت نشد</p>
                          </template>

                          <template slot="isBaradarShahid" slot-scope="props">
                            <i v-if="props.row.isBaradarShahid" class="fas fa-check text-success"></i>
                            <i v-else class="fas fa-times text-danger"></i>
                          </template>
                          <template slot="isKhanevadeShahid" slot-scope="props">
                            <i v-if="props.row.isKhanevadeShahid" class="fas fa-check text-success"></i>
                            <i v-else class="fas fa-times text-danger"></i>
                          </template>
                          <template slot="isRazmande" slot-scope="props">
                            <i v-if="props.row.isRazmande" class="fas fa-check text-success"></i>
                            <i v-else class="fas fa-times text-danger"></i>
                          </template>
                          <template slot="isJanbaz" slot-scope="props">
                            <i v-if="props.row.isJanbaz" class="fas fa-check text-success"></i>
                            <i v-else class="fas fa-times text-danger"></i>
                          </template>
                          <template slot="isAzade" slot-scope="props">
                            <i v-if="props.row.isAzade" class="fas fa-check text-success"></i>
                            <i v-else class="fas fa-times text-danger"></i>
                          </template>
                        </vue-bootstrap4-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div class="col-1"></div>
    </div>
    <!-- <div class="row my-2">
      <div class="col-1"></div>
      <div class="col-md-10 col-12 px-2">
        <net-pa-card>
          <template slot="header">
            <h6><i class="fas fa-unlock-alt mx-2"></i>تغییر رمز عبور</h6>
          </template>
          <template slot="content">
            <div class="row px-3">
              <div class="col-12 alert bg-dark-Custom NetPa-btn text-light text-right">
                <span class="badge badge-warning my-2 p-1"> هشدار امنیتی</span>
                <ul style="list-style: number; font-size: 15px" class="p-0">
                  <li>جهت جلوگیری از سوء استفاده ، رمز اینترنت بانک خودرا هر چندمدت یکبار تعویض نمایید .</li>
                  <li>برای امنیت بیشتر بهتر است ( رمز اینترنت بانک شما شامل حروف بزرگ و کوچک انگلیسی و اعداد باشد ) .</li>
                </ul>
              </div>
            </div>
            <div class="row px-3">
              <div class="col-md-4 col-12 mt-1">
                <input type="password" v-model="oldpass" class="form-control text-center" placeholder="رمز عبور فعلی" />
              </div>
              <div class="col-md-4 col-12 mt-1">
                <input type="password" v-model="newpass" @keypress="checkregex($event)" class="form-control text-center" placeholder="رمز  جدید" />
              </div>
              <div class="col-md-4 col-12 mt-1">
                <input type="password" v-model="newpasscomfirm" @keypress="checkregex($event)" class="form-control text-center" placeholder="تکرار رمز جدید" />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-4 col-12"></div>
              <div class="col-md-4 col-12"></div>
              <div class="col-md-4 col-12 float-left">
                <button class="btn btn-dark NetPa-btn float-left mt-2 w-100" @click="ChangePass">تغییر رمز &nbsp;</button>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div class="col-1"></div>
    </div> -->
  </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import Panel from '../Tools/NetPa/Panel.vue'
import loading from '../Tools/NetPa/Loading.vue'
import uploader from './Componenets/NetpaUploader.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import SelectCombo from '@/components/Tools/SelectCombo.vue'
export default {
  data() {
    return {
      DataAxiosEstelamSabtAhval: { CodeMeli: '', Mobile: '', BirthDate: '', CustCode: this.$session.get('CustCode') },
      // DataAxiosEstelamSabtAhval: { CodeMeli: '', Mobile: '', BirthDate: '', CustCode: 7777 },
      stage: 1,
      ResultStage1: {},
      ResultStage2: {},
      randomKey: null,
      FixInput: false,
      value: null,
      file: [],
      UserInfo: {},
      bankAcoount: {},
      newpass: '',
      oldpass: '',
      addBankAccount: false,
      canChange: {},
      newpasscomfirm: '',
      DataAxiosChange: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'UpdPass/netpaUpdPass',
        Token: this.$session.get('TokenNetPa'),
      },
      loadingRender: false,
      rows: [],
      columns: [
        { label: 'نام صاحب حساب', name: 'nameSahebHesab' },
        { label: 'نام بانک ', name: 'bankName' },
        { label: 'شماره حساب', name: 'hesabNo' },
        { label: 'شماره کارت', name: 'cardNo' },
        { label: 'شماره شبا', name: 'shebaNo' },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: '  جستجو   ',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },
      columnsIsar: [
        { label: 'آزادگی', name: 'isAzade' },
        { label: 'جانبازی', name: 'isJanbaz' },
        { label: 'رزمنده', name: 'isRazmande' },
        { label: 'مدت اسارت (سال)', name: 'salEsarat' },
        { label: 'درصد جانبازی', name: 'darsadJanbazi' },
        { label: 'تعداد ماه عملیات', name: 'mahAmaliyat' },
        { label: 'خانواده شهید', name: 'isKhanevadeShahid' },
        { label: 'برادر شهید', name: 'isBaradarShahid' },
      ],
      rowsIsar: [],
      tabMenus: this.$session.get('AccessMenu').filter((x) => x.routeName == 'Tab'),
      EstlamSuccess: false,
    }
  },
  components: { VueBootstrap4Table, NetPaCard, Panel, loading, uploader, SelectCombo },
  created() {
    if (this.NeedEstelam == true) {
      this.DataAxiosEstelamSabtAhval.CodeMeli = this.$session.get('UserInfoNetPa').codeMeli.trim()
    }
    if (this.$session.get('CustCode') == '932' || this.$session.get('CustCode') == '8002') {
      this.FixInput = true
      this.bankAcoount.NameSahebHesab=this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily 
    }
    this.getAzaNoe()
    // this.UserInfo = JSON.parse(JSON.stringify(this.$session.get('UserInfoNetPa')))
    // this.UserInfo.codeMeli = this.UserInfo.codeMeli.trim()
    // this.UserInfo.shomareOzv = this.UserInfo.shomareOzv.trim()
    // this.GetFile()
    this.GetOzv()
    this.GEtAzaHesab()
    this.GEtAzaIsar()
  },
  methods: {
    submitBankAcoount() {
      if (this.$ValidForm('addAccountBank') == false) {
        return
      }
      this.$PostData_new('SelAzaHesab/AddBankAccount', 'post', this.bankAcoount)
        .then((res) => {
          this.$mySweetDefaultTost('', 'اطلاعات با موفقیت افزوده شد', 'success', 2000)
          this.GEtAzaHesab()
          this.addBankAccount = false
        })
        .catch((err) => {
          this.$mySweetDefaultTost('', 'خطای سمت سرور', 'error', 2000)
          console.error('e', err)
        })
    },
    // دسترسی نمایش تب ها که از جدول wwwtblMenu میخونه
    showTab(num) {
      try {
        let tab = this.tabMenus.find((x) => x.params == num)
        if ((num != 0 && num != 1) && this.NeedEstelam == true) {
          return false
        }
        if ((num == 0 || num == 1) && this.NeedEstelam == true && this.EstlamSuccess == false) {
          return false
        }
        return tab.isMenu
      } catch (err) {
        console.error('e', err)
        return true
      }
    },
    bankAccountChange(add) {
      this.addBankAccount = add
    },
    test() {
      console.log('^^')
    },
    GetAddress(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id)
      if (binary) {
        if (binary.filename.indexOf('.PDF') > 0 || binary.filename.indexOf('.pdf') > 0) {
          return '/Image/PdfFile.png'
        }
        if (binary.filename.indexOf('.zip') > 0 || binary.filename.indexOf('.rar') > 0) {
          return '/Image/ZipFile.png'
        }
        return 'data:image/png;base64,' + binary.binary
      } else {
        return null
      }
    },
    GetId(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id)
      if (binary) {
        return binary.id
      } else {
        return null
      }
    },
    GetFile() {
      var dataAxios = {
        Method: 'POST',
        Action: 'Uploader/GetFile',
        ArryfildValue: {
          MasterId: this.$session.get('UserInfoNetPa').wwwtblAzaId,
          tableName: 'wwwtblaza',
        },
      }
      this.$PostData(dataAxios).then((result) => {
        console.log("🤦🏻‍♂️ ~ file: UserInfo.vue:610 ~ result:", result)
        this.file = result.data
        this.$store.state.renderComponent = false
        this.$nextTick(() => {
          this.$store.state.renderComponent = true
        })
      })
    },
    getSelectedBank(item) {
      this.bankAcoount.WwwtblBankId = item.id
    },
    ChangePass() {
      if (this.newpasscomfirm == this.newpass) {
        this.loadingRender = true
        const formData = new FormData()
        formData.append('CustCode', this.$session.get('UserInfoNetPa').custCode)
        formData.append('CodeMeli', this.$session.get('UserInfoNetPa').codemeli)
        formData.append('AxarinTaghirPass', this.$store.state.JalaliDate)
        formData.append('wwwtblazaId', this.$session.get('UserInfoNetPa').id)
        formData.append('NewPassword', this.$Encryption(this.newpass))
        formData.append('OldPass', this.$Encryption(this.oldpass))

        this.DataAxiosChange.ArryfildValue = formData
        this.$PostFormData(this.DataAxiosChange).then((data) => {
          if (data.status) {
            this.$mySweetDefaultTost('خطا', data.msg, 'warning', 2000)
            this.loadingRender = false
          } else {
            if (data.id) {
              this.$mySweetDefaultTost('عملیات موفق', 'تغییر رمز با موفقیت انجام شد', 'success', 2000)
              this.loadingRender = false
            }
          }
        })
      } else {
        this.$mySweetDefaultTost('خطا', 'رمز عبور وارد شده و تکرارش برابر نیستند!', 'warning', 2000)
      }
    },
    getSelectedCombo(item) {
      this.UserInfo.comboIdNoeEstekhdam33 = item.id
    },
    UpdateUser() {
      if (this.$ValidForm('userInfoDiv')) {
        if(this.rows.length==0 && this.NeedEstelam){
          this.$mySweetDefaultTost('عدم ثبت اطلاعات', 'اطلاعات حساب بانکی یافت نشد لطفا اطلاعات حساب بانکی خودرا وارد نمایید', 'warning', 4000)
          return
        }
        this.$RemoveAlert('از صحت اطلاعات اطمینان دارین؟').then((res) => {
          if (res) {
            var form_data = new FormData()
            for (var key in this.UserInfo) {
              form_data.append(key, this.UserInfo[key])
            }
            form_data.append('IsEstelamSabtAhval', this.NeedEstelam == true ? true : null)
            var DataAxiosUpdate = {
              ArryfildValue: form_data,
              Method: 'Post',
              Action: 'UpdAza',
              Token: this.$session.get('TokenNetPa'),
            }
            this.$PostFormData(DataAxiosUpdate).then((data) => {
              if (data.id) {
                if (this.NeedEstelam == true) {
                  this.$mySweetDefault('عملیات موفق', 'احراز هویت شما با موفقیت انجام شد و اطلاعات شما بروز گردید ، لطفا جهت بروزرسانی اطلاعات شما دوباره وارد سیستم شوید', 'success', 4000)
                  this.LogOut()
                  return
                }
                this.$mySweetDefaultTost('عملیات موفق', 'اطلاعات با موفقیت بروز شدند', 'success', 2000)
              } else {
                this.$mySweetDefaultTost('عملیات ناموفق', 'مشکلی در ثبت اطلاعات بوجود آمده است. دوباره تلاش کنید', 'error', 2000)
              }
            })
          }
        })
      }
    },
    getAzaNoe() {
      var formdata = new FormData()
      formdata.append('wwwtblShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId)
      formdata.append('wwwtblAzaNoeId', this.$session.get('UserInfoNetPa').wwwtblAzaNoeId)
      var DataAxiosUpdate = {
        ArryfildValue: formdata,
        Method: 'POST',
        Action: 'Dastresi',
        Token: this.$session.get('TokenNetPa'),
      }
      this.$PostFormData(DataAxiosUpdate).then((data) => {
        if (this.$session.get('UserInfoNetPa').cId != '801') {
          this.canChange = data
        }
      })
    },
    checkregex(e) {
      let char = String.fromCharCode(e.keyCode)
      if (!/^[A-Za-z0-9]+$/.test(char)) {
        this.$mySweetDefaultTost('خطا', 'فقط حروف انگلیسی و اعداد  مجاز هستند', 'error', 2000)
        e.preventDefault()
      }
    },
    GetBase(id) {
        var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id)
        if (binary) {
          return binary
        } else {
          return null
        }
    },
    GetOzv() {
      var formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      var DataAxios = { Method: 'Post', Action: 'SelAza', ArryfildValue: formData, Token: this.$session.get('TokenNetPa') }
      this.$PostFormData(DataAxios).then((result) => {
        this.UserInfo = result
        this.UserInfo.codeMeli = this.UserInfo.codeMeli.trim()
        this.UserInfo.shomareOzv = this.UserInfo.shomareOzv.trim()
      })
    },
    GEtAzaHesab() {
      var formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      var DataAxios = { Method: 'Post', Action: 'SelAzaHesab', ArryfildValue: formData, Token: this.$session.get('TokenNetPa') }
      this.$PostFormData(DataAxios).then((result) => {
        this.rows = result
      })
    },
    GEtAzaIsar() {
      var formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      var DataAxios = { Method: 'Post', Action: 'IsarGari', ArryfildValue: formData, Token: this.$session.get('TokenNetPa') }
      this.$PostFormData(DataAxios).then((result) => {
        this.rowsIsar = result
      })
    },
    sendSms(IdFormValid) {
      if (!this.$ValidForm(IdFormValid)) {
        return
      }

      this.loadingRender = true
      this.$PostData_new('GetInfocodeMeli', 'POST', this.DataAxiosEstelamSabtAhval).then((re) => {
        if (re.result == 'false') {
          this.$mySweetDefaultTost('خطا', re.msg, 'error', 3800)
        }
        if (re.result == 'faild') {
          this.$mySweetDefaultTost('عدم احراز هویت', re.msg, 'warning', 4500)
        }
        if (re.result.id) {
          this.ResultStage1 = re
          this.stage = 2
          this.$mySweetDefaultTost('ارسال موفق', 'کد احراز هویت برای شما پیامک شد ، دریافت کد به علت ترافیک پیامک ها ممکن است کمی زمان بر باشد', 'success', 4500)
        }
        this.loadingRender = false
      })
    },
    OkCode(IdFormValid) {
      if (!this.$ValidForm(IdFormValid)) {
        return
      }
      this.loadingRender = true
      let Model = { ResultId: this.ResultStage1.result.id, ComfirmMobile: this.randomKey }
      this.$PostData_new('GetInfocodeMeliByOTP', 'POST', Model).then((re) => {
        if (re == null || re.result == 'false' || re.result.idCode == null) {
          this.$mySweetDefaultTost('خطا', re.result == 'false' ? re.msg : 'خطا در بررسی کد احراز هویت ، کد وارد شده صحیح نیست', 'error', 4800)
          this.loadingRender = false
          this.stage = 2
          return
        }
        if (re.result.id != null && re.result.id.trim() != '') {
          this.loadingRender = false
          this.$mySweetDefaultTost('احراز موفق', 'کاربر گرامی : ' + re.result.name + ' ' + re.result.family + ' احراز هویت شما با موفقیت انجام گردید ', 'success', 4800)
          this.stage = 3
          this.ResultStage2 = re
          this.EstlamSuccess = true
          this.FixInput = true
          this.UserInfo.ozvName = re.result.name
          this.UserInfo.ozvFamily = re.result.family
          this.UserInfo.codeMeli = re.result.idCode
          this.UserInfo.birthDate = re.result.birthDate
          this.UserInfo.mobile = re.result.mobile
          this.UserInfo.pedar = re.result.fatherName
        } else {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد است', 'error', 2000)
          this.loadingRender = false
        }
        this.loadingRender = false
      })
    },
    LogOut() {
      this.$store.state.Netpa_Cart = []
      this.$router.push('/')
      this.$session.clear()
      sessionStorage.removeItem('vuex')
      this.$store.state.PanelRout = []
      this.$ResetTimer()
    },
  },
  props: ['NeedEstelam'],
}
</script>
<style scoped>
.btn-submit {
  color: blanchedalmond !important;
  background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%, rgba(72, 20, 193, 1) 100%);
  /* background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%,#403c47 100%); */
}

.btn-submit:hover {
  color: blueviolet !important;
  background: #f8f9fa;
  border: solid 3px rgba(72, 20, 193, 1);
}
</style>
